import { connect } from 'react-redux'; 
import React, { useEffect, useState } from "react";
import addDays from "date-fns/addDays";




    



const Overview = () => {
    useEffect(() => {
        let repeat = setTimeout(fetchData, 1);

        async function fetchData() {
            try {
                checkNext14DaysReservations();

                repeat = setTimeout(fetchData, 900000); // request again after 15 minutes
            } catch (error) {
                console.error(error.message)
            }
        }
        

        return () => {
            if (repeat) {
                clearTimeout(repeat);
            }
        }
    }, []);

    async function checkNext14DaysReservations() {
        var today = new Date()
        const response = await fetch('overview?today='+today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate());
        const data = await response.json();
        setReservationData(data);
    }

    

    

    



    var [reservationData, setReservationData] = useState([]);

    return (
        <div>
            <h1>Kommende begivenheder:</h1>

            <table id="events">
                    <thead>
                        <tr>
                            <th>Uge dag</th>
                            <th>Dato</th>
                            <th>begivenhed</th>
                            <th>Reserveret af</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reservationData.map(data =>
                            <tr>
                                <td>{data[0]}</td>
                                <td>{data[1]}</td>
                                <td>{data[2]}</td>
                                <td>{data[3]}</td>
                                
                            </tr>
                        )}
                    </tbody>
                </table>

                

            </div>
        );
    
};

export default connect()(Overview);


